import businessAddressesService from "@/services/businessAddresses";
import serviceHandler from "@/helpers/handlers/service";

export default {
  async getBusinessAddresses({ commit }) {
    commit("SET_LOADING", true);
    const businessAddresses = await serviceHandler(
      businessAddressesService.getBusinessAddressesData()
    );

    if (businessAddresses.length > 0) {
      commit("SET_BUSINESS_ADDRESSES", businessAddresses);
    }

    commit("SET_LOADING", false);
  }
};
